import $http from '@/plugins/axios'
import store from "@/store/store";
import $const from "@/utils/const";
import md5 from 'md5';
import _ from 'lodash'
import {storage} from '../utils/map'

const JWT_KEY = 'fptai_messenger_user_jwt';

const StaffService = {
    getMe () {
        return storage.has(JWT_KEY) ? storage.getItem(JWT_KEY).user : null
    },
    getJwt () {
        return storage.has(JWT_KEY) ? storage.getItem(JWT_KEY).user_token : null
    },
    getAvailableStaff () {
        return $http.get(process.env.VUE_APP_BASE_API_MESSENGER + '/live-support/get-bot-staff/')
    },
    getBotStaff(botCode) {
        return $http.get(process.env.VUE_APP_BASE_API_MESSENGER + '/live-support/get-bot-staff/'+ botCode)
    },
    createRoom (fromUserId, toUserId, channel) {
        let from = fromUserId;
        let to = toUserId;
        if (from > to) {
            from = toUserId;
            to = fromUserId
        }
        let encryptString = md5(from + '.' + to);
        return encryptString + '@' + channel
    },
    startConversation (fromUserId, toUserId) {
        let subscribeChannel = this.createRoom(fromUserId, toUserId, 'private');
        if (store.state.scClient) {
            return store.state.scClient.subscribe(subscribeChannel)
        }
        return null
    },
    sendMessage (jwToken, fromUserId, toUserId, type, content) {
        let data_msg = {
            "jw_token": jwToken,
            "channel": 'private',
            "from_user_id": fromUserId,
            "to_user_id": toUserId,
            "message": {
                "type": type,
                "text": content
            }
        };
        store.state.scClient.emit('admin_send_message', data_msg)
    },
    getChatLogs (fromUserId, toUserId, lastChatLogId) {
        let channelId = this.createRoom(fromUserId, toUserId, 'private');
        let url = `/live-support/get-admin-with-admin-chatlog/${channelId}/?page_size=20`;
        if (lastChatLogId) {
            url += '&last_id=' + lastChatLogId;
        }
        return $http.get(url);
    },
    assignTo(staffId, current_livesupport_log, ignore_max_supporting = false) {
        return $http.put(`/live-support/${store.state.chatView.botCode}/assign-customer-to-supporter/`, {
            "assign_to_uid": staffId,
            "sender_id": store.state.chatView.senderId,
            "channel": store.getters.channel,
            "current_livesupport_log": current_livesupport_log,
            "ignore_max_supporting": ignore_max_supporting,
        })
    },
    assignBySkill (skillId, current_livesupport_log) {
        return $http.put(`/live-support/${store.state.chatView.botCode}/assign-customer-to-supporter-by-skill/`, {
            "assign_to_skill_id": skillId,
            "sender_id": store.state.chatView.senderId,
            "channel": store.getters.channel,
            "current_livesupport_log": current_livesupport_log
        })
    },
    getStaffById (id) {
        return _.find(store.state.staffList, item => item.id === id)
    },
    getSupportingStatus () {
        let bot = _.find(store.state.botStaffList, bot => bot.bot_code === store.state.chatView.botCode);
        return $http.post(
            `/live-support/${store.state.chatView.botCode}/get-number-of-customer-in-support/`,
            {
                list_supporters: bot.staffs.map(item => {
                    return { id: item.id }
                })
            }
        )
    },
    checkStaffHasRole(botCode, userId, roles = []) {
        if (!botCode || !userId || !roles || roles.length === 0) {
            return false;
        }
        let botStaff = _.find(store.state.botStaffList, item => item.bot_code === botCode);
        if (!botStaff || !botStaff.staffs || botStaff.staffs.length === 0) {
            return false;
        }
        botStaff = botStaff.staffs;
        let staff = _.find(botStaff, item => item.id === userId);
        if (!staff) {
            return false;
        }
        if (JSON.stringify(roles) === JSON.stringify([10, 9, 5])) {
            return !!staff.role_features && staff.role_features.includes($const.ROLE_FEATURES.ACCESS_LIVE_SUPPORT_PAGE_AS_LEADER)
        } else {
            return roles.includes(staff.role_level);
        }
    },
    checkStaffHasRoleFeature(botCode, userId, role_feature) {
        if (!botCode || !userId || !role_feature || role_feature.length === 0) {
            return false;
        }
        let botStaff = _.find(store.state.botStaffList, item => item.bot_code === botCode);
        if (!botStaff || !botStaff.staffs || botStaff.staffs.length === 0) {
            return false;
        }
        botStaff = botStaff.staffs;
        let staff = _.find(botStaff, item => item.id === userId);
        if (!staff) {
            return false;
        }
        return !!staff.role_features && staff.role_features.includes(role_feature)
    },
};

export default StaffService
